import React from 'react';
import PencilIcon from '../icons/pencilIcon';
import style from './policyHolderClaimReviewAcceptedRejectedWordings.module.scss';
// @ts-ignore
import { Heading } from 'arag-ui-lib';
import PhoneIcon from '../icons/phoneIcon';
import { useAppSelector } from '../../hooks/hooks';
import { useTranslation } from 'react-i18next';
import claimReviewProjections from '../../projections/claimReview';

type AcceptedRejectedWording = {
    title: string;
    subtitle: string;
    contact: string;
    aragTelephoneNumber?: string | number;
    languageId: string;
};
type Props = {
    acceptedRejectedWordings: AcceptedRejectedWording[];
};
const PolicyHolderClaimReviewAcceptedRejectedWordings = (
    props: Props,
): JSX.Element => {
    const { t } = useTranslation();

    const acceptedRejectedWording = useAppSelector(
        claimReviewProjections.acceptedRejectedWordings,
    );
    return (
        <div id="accepted_rejected_claim_review" className={''}>
            <div id="accepted_rejected_claim_review_row" className={'row'}>
                <div
                    id="accepted_rejected_claim_review_wordings"
                    className="col-sm-8"
                >
                    {acceptedRejectedWording?.title && (
                        <div className={`${style['accepted-wordings']}`}>
                            {acceptedRejectedWording?.title}
                        </div>
                    )}
                    {acceptedRejectedWording?.subtitle && (
                        <div className={`${style['accepted-wordings']}`}>
                            {acceptedRejectedWording.subtitle}
                        </div>
                    )}
                    {acceptedRejectedWording?.contact && (
                        <div className={`${style['accepted-wordings']}`}>
                            {acceptedRejectedWording?.contact}
                        </div>
                    )}
                </div>
                <div
                    id="accepted_rejected_claim_review_arag_details"
                    className="col-sm-4"
                >
                    <div className="col-xs-2 col-sm-4 col-md-4">
                        <PhoneIcon className={`${style['icon']}`} />
                    </div>
                    <div className="col-xs-10 col-sm-8 col-md-8">
                        <Heading
                            variant="h2"
                            title={t<string>('textCallEmail')}
                        />
                        <div className={`${style['informations']}`}>
                            <div>{t<string>('aragEmail')}</div>
                            <div>{t('aragTelephoneNumber') as string}</div>
                        </div>
                    </div>
                    <div className="col-xs-2 col-sm-4 col-md-4">
                        <PencilIcon className={`${style['icon']}`} />
                    </div>
                    <div className="col-xs-9 col-sm-8 col-md-8">
                        <Heading variant="h2" title={t<string>('textWrite')} />
                        <div className={`${style['informations']}`}>
                            <div>{t('aragAddress') as string}</div>
                            <div>{t('aragStreet') as string}</div>
                            <div>{t('aragCounty') as string}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PolicyHolderClaimReviewAcceptedRejectedWordings;
